import { Pipe, PipeTransform } from '@angular/core';
import { TypeDocument } from '../../models/typeDocument';

@Pipe({
	name: 'filterTypeDocumentByName'
})
export class FilterTypeDocumentByNamePipe implements PipeTransform {
	transform(typeDocument: TypeDocument[], filter: string): TypeDocument[] {
		if (
			!typeDocument ||
			!filter ||
			typeDocument === null ||
			filter === null ||
			filter === ''
		) {
			return typeDocument;
		}

		return typeDocument.filter((typeDocument: TypeDocument) => {
			if (typeDocument.name) {
				// TODO: add lastName too
				return typeDocument.name.toLowerCase().includes(filter.toLowerCase());
			}
			return false;
		});
	}
}
